module.exports = __webpack_public_path__ + "img/logo-school-9.5de0df24.png";